import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Play, Heart, Activity, Thermometer, Monitor } from "lucide-react";
import { Link } from "react-router-dom";
import { useVitalsData } from "../hooks/useVitalsData";
import ECGWave from "./ECGWave";

const HeroSection = () => {
  const vitals = useVitalsData();

  return (
    <section className="hero" id="home">
      <div className="hero-inner">
        <motion.div
          className="hero-left"
          initial={{ opacity: 0, x: -40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          {/* <h1 className="hero-title">
            Next-Gen <span className="accent">IoT Healthcare</span>
            <br />Monitoring System
          </h1> */}
          <h1 className="hero-title">
  <span className="accent">Medico.in</span>
</h1>

          <p className="hero-sub">
            Real-time patient monitoring with advanced IoT sensors, AI-powered analytics,
            and seamless cloud connectivity for healthcare professionals.
          </p>
          <div className="hero-ctas">
            <Link to="/auth" className="btn btn-primary">
              Get Started <ArrowRight className="icon-sm" />
            </Link>
            <button className="btn btn-outline">
              <Play className="icon-sm" /> Watch Demo
            </button>
          </div>
        </motion.div>

        <motion.div
          className="hero-right"
          initial={{ opacity: 0, x: 40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <div className="vitals-card">
            <div className="vitals-header">
              <h3>Live Patient Vitals</h3>
              <div className="live-indicator"><span className="dot" />Live</div>
            </div>

            <div className="vitals-grid">
              <div className="vital red">
                <div className="vital-top"><Heart className="icon" /><span>Heart Rate</span></div>
                <div className="vital-value">{vitals.heartRate}</div>
                <div className="vital-unit">BPM</div>
              </div>

              <div className="vital blue">
                <div className="vital-top"><Activity className="icon" /><span>SpO2</span></div>
                <div className="vital-value">{vitals.spO2}%</div>
                <div className="vital-unit">Oxygen</div>
              </div>

              <div className="vital orange">
                <div className="vital-top"><Thermometer className="icon" /><span>Temperature</span></div>
                <div className="vital-value">{vitals.temperature}°F</div>
                <div className="vital-unit">Body Temp</div>
              </div>

              <div className="vital purple">
                <div className="vital-top"><Monitor className="icon" /><span>Blood Pressure</span></div>
                <div className="vital-value">{vitals.bloodPressure.systolic}/{vitals.bloodPressure.diastolic}</div>
                <div className="vital-unit">mmHg</div>
              </div>
            </div>

            <div className="ecg-section">
              <div className="ecg-header">
                <span>ECG Reading</span>
                <span className="ecg-status">Normal Rhythm</span>
              </div>
              <div className="ecg-wrap"><ECGWave /></div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
